export default "https://cdn-static.gokick.com/assets/38a17193d7f2ad0638d84ec7199a8f76eb0c19ef/images/diastolic-smaller.c0fadbcdc01bd506880e051915c30039.svg";